export default {
  sorry: 'Leider',
  sorryClass: 'Leider konnten wir keine Sitze in ',
  weFound: 'konnten wir ',
  noResults: 'keine Ergebnisse',
  fares: '',
  theseDates: ' für diese Daten finden.',
  matchingSearch: 'für Ihre Suche finden.',
}
